module.exports = __webpack_public_path__ + "media/bootstrap-icons/x-square-009959ea.svg";